var i={circle:{S:{px:"S",py:"S",iconSize:"S"},M:{px:"M",py:"M",iconSize:"L"},radius:"MAX"},square:{radius:"S",iconSize:"L"}};export{i as default};
